import {
    configureFormatLargeAmountCurrency,
    getCurrency,
    getCurrencySymbolPosition,
    getNumberAsCurrency,
    getStringAsCurrency,
    setupCurrencyLocaleUser,
} from '@Sage/ssm-utils';

import { formatLargeAmountCurrency } from 'utils/amount';

configureFormatLargeAmountCurrency(formatLargeAmountCurrency);

export { getCurrency, setupCurrencyLocaleUser };

export { getNumberAsCurrency };
